import { BASE_API_URL } from "../../config/Api";
import { ADD_CLIENT, ADD_CUSTOMER_DATA, ADD_DESIGNATION_DATA, ADD_NOTICE, ADD_PROJECT_DATA, CLIENT_DATA, CLIENT_DETAILS, CUSTOMER_LIST, EMAIL_DATA, NOTICE_DATA, NOTICE_DETAILS } from "./ActionType";

export const addClientDetails=(formData,token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/addClientDetails`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(formData),
        })
        const resData=await res.json();
        if (res.ok) {
            dispatch({ type: ADD_CLIENT, payload: resData });
            return resData;
        } else {
            throw new Error(resData.statusDesc || 'Unknown error occurred');
        }
    } catch (error) {
         console.error("Error:", error);
    }
}

export const fetchClientDetails=(token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/fetchClientDetails`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:CLIENT_DETAILS, payload:resData})
    } catch (error) {
        
    }
}

export const fetchClientData = (clientMasterId, token) => async (dispatch) => {
    try {
      const res = await fetch(
        `${BASE_API_URL}/fetchClientDataById?clientMasterId=${clientMasterId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const resData = await res.json();
      dispatch({ type: CLIENT_DATA, payload: resData });
    } catch (error) {}
  };

  export const fetchNoticeData = (noticeId, token) => async (dispatch) => {
    try {
      const res = await fetch(
        `${BASE_API_URL}/fetchNoticeDataById?noticeId=${noticeId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const resData = await res.json();
      dispatch({ type: NOTICE_DATA, payload: resData });
    } catch (error) {}
  };

  export const addNoticeDetails=(formData,token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/addNoticeDetails`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(formData),
        })
        const resData=await res.json();
        if (res.ok) {
            dispatch({ type: ADD_NOTICE, payload: resData });
            return resData;
        } else {
            throw new Error(resData.statusDesc || 'Unknown error occurred');
        }
    } catch (error) {
         console.error("Error:", error);
    }
}

export const fetchNoticeDetails=(token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/fetchNoticeDetails`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:NOTICE_DETAILS, payload:resData})
    } catch (error) {
        
    }
}

export const addProjectData = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/add-project-data`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: ADD_PROJECT_DATA, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in addProjectData:", error);
    }
}

export const addCustomerData = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/add-customer-data`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: ADD_CUSTOMER_DATA, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in addCustomerData:", error);
    }
}

export const getCustomerList = (token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/get-customer-list`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: CUSTOMER_LIST, payload: resData })
    } catch (error) {
        console.error("Error in fetching customer list:", error);
    }
};

export const addDesignation = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/add-designation-data`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: ADD_DESIGNATION_DATA, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in addCustomerData:", error);
    }
}

export const getEmailData = (token, fromDate, toDate) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/email-data?fromDate=${fromDate}&toDate=${toDate}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: EMAIL_DATA, payload: resData })
    } catch (error) {
        console.error("Error in fetching email data:", error);
    }
};